import { ThemeInterface, themeNames } from "../theme";
import { colors } from "../../styles/variables";
import { FontNames, FontWeights, HexColor } from "../../types/styles";

type PoppiColorNames = "white" | "blue" | "darkBlue" | "lightBlue";

// poppi — official brand palette
export const POPPI_COLORS: Record<PoppiColorNames, HexColor> = {
  white: "#ffffff",
  blue: "#0084d4", // Blue (primary)
  darkBlue: "#006bad", // darker shade of brand blue for hover/depth
  lightBlue: "#8dbfe8", // Light blue (accent)
};

const SHARED_HEADING_STYLES = {
  // Toroka display typeface for headlines (H1–H5)
  fontFamily: "font-secondary" as FontNames,
  fontWeight: "700" as FontWeights,
  color: POPPI_COLORS.blue,
};

export const PoppiTheme: ThemeInterface = {
  name: themeNames.Poppi,
  color: {
    primary: POPPI_COLORS.blue,
    secondary: POPPI_COLORS.darkBlue,
    tertiary: POPPI_COLORS.darkBlue,
    accent: POPPI_COLORS.lightBlue,
    disabled: colors.gray300,
    action: colors.green,
    error: colors.red,
    text: colors.gray900,
  },
  button: {
    primary: {
      color: POPPI_COLORS.blue,
    },
    secondary: {
      color: POPPI_COLORS.darkBlue,
    },
    tertiary: {
      color: POPPI_COLORS.blue,
      hollow: true,
    },
    cancel: {
      color: colors.gray600,
      hollow: true,
    },
    error: {
      color: colors.red,
      hollow: true,
    },
    text: {
      color: POPPI_COLORS.blue,
    },
    disabled: {
      hollow: true,
    },
    fontWeight: "700",
    // Pill-shaped buttons for the playful poppi look
    borderRadius: "100px",
  },
  priceAccentColor: POPPI_COLORS.blue,
  typography: {
    heading: {
      xxl: {
        fontSize: {
          desktop: "46px",
          mobile: "32px",
        },
        letterSpacing: "-1px",
        ...SHARED_HEADING_STYLES,
        lineHeight: "133%", // H1
      },
      xl: {
        fontSize: {
          desktop: "36px",
          mobile: "24px",
        },
        letterSpacing: "-1px",
        ...SHARED_HEADING_STYLES,
        lineHeight: "100%", // H2
      },
      l: {
        fontSize: {
          desktop: "24px",
          mobile: "20px",
        },
        letterSpacing: "-1px",
        ...SHARED_HEADING_STYLES,
        lineHeight: "110%", // H3
      },
      m: {
        fontSize: {
          desktop: "18px",
          mobile: "18px",
        },
        ...SHARED_HEADING_STYLES,
        lineHeight: "130%", // H4
      },
      s: {
        fontSize: {
          desktop: "16px",
          mobile: "16px",
        },
        ...SHARED_HEADING_STYLES,
        lineHeight: "110%", // H5
      },
      xs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        ...SHARED_HEADING_STYLES,
      },
      xxs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        fontFamily: "font-primary",
        fontWeight: "400",
        color: colors.gray900,
      },
    },
  },
};
